import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* contentViewPlansWatchers() {
  yield all([
    takeEvery(
      EntryActionTypes.CONTENT_VIEW_PLANS_IN_CURRENT_BOARD_FETCH,
      ({ payload }) => services.fetchContentViewPlansInCurrentBoard(payload?.pointSystemId || null),
    ),
    takeEvery(
      EntryActionTypes.CONTENT_VIEW_PLAN_IN_CURRENT_BOARD_GET_OR_CREATE,
      ({ payload: { year, month, pointSystemId, values } }) =>
        services.getOrCreateContentViewPlanInCurrentBoard(
          year,
          month,
          pointSystemId || null,
          values || null,
        ),
    ),
    takeEvery(EntryActionTypes.CONTENT_VIEW_PLAN_UPDATE, ({ payload: { id, data } }) =>
      services.updateContentViewPlan(id, data),
    ),
  ]);
}

